import styled from 'styled-components';

export const List = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: 0px;
    margin-bottom: 20px;
`;
